<template>
  <div class="table-container">
    <vab-query-form>
        <el-button v-permission="'GoodsPostage_add'" icon="el-icon-plus" type="primary" @click="handleAdd(0)">
          添加
        </el-button>
    </vab-query-form>

    <el-table ref="tableSort" v-loading="listLoading" class="table" :data="list"
      :element-loading-text="elementLoadingText" :height="height" border>
      <!-- 名称 -->
      <el-table-column  prop="name" label="名称" align="center"></el-table-column>
      <el-table-column  prop="name" label="状态" align="center">
        <template #default="{ row }">
            <span>{{row.status==0?'正常':'关闭'}}</span>
        </template>
      </el-table-column>
      <el-table-column   label="创建时间" prop="add_time"
        align="center"></el-table-column>
      <el-table-column  fixed="right"  label="操作面板" width="130px" align="center">
        <template #default="{ row }">
          <el-button type="text" @click="handleAdd(row.id)">编辑</el-button>
          <el-button type="text" @click="handleDelete(row)">删除</el-button>
          <el-button type="text" @click="handleList(row)">模版列表</el-button>
        </template>
      </el-table-column>
    </el-table>
    <!-- 编辑/添加 -->
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="50vw"
      :before-close="handleClose">
      <el-form :model="submit_form" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
        <el-form-item label="模版名称" prop="name">
          <el-input v-model="submit_form.name" maxlength="20" show-word-limit></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort">
          <el-input v-model="submit_form.sort" maxlength="5" show-word-limit></el-input>
        </el-form-item>
        <!-- <el-form-item label="包邮条件" prop="price">
          <el-input v-model="submit_form.price" @input="(e)=>{submit_form.price = $geShi(e)}" maxlength="15" show-word-limit></el-input>
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="submit_form.status">
          <el-radio :label="0">正常</el-radio>
            <el-radio :label="1">关闭</el-radio>
          </el-radio-group>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit_save()">确 定</el-button>
      </span>
    </el-dialog>
    <el-pagination style="position: absolute; left: 0; right: 0; bottom: 20px; margin: auto" :background="background"
      :current-page="queryForm.page" :layout="layout" :page-size="queryForm.limit" :total="queryForm.total"
      @current-change="handleCurrentChange" @size-change="handleSizeChange"></el-pagination>
  </div>
</template>

<script>
  import {
    goodsPostagePostageList,
    goodsPostagePostageAdd,
    goodsPostagePostageDetail,
    goodsPostagePostageUpdate,
    goodsPostagePostageDel
  } from '@/api/xgcApi'
  export default {
    name: 'ComprehensiveTable',
    filters: {
      statusFilter(status) {
        const statusMap = {
          published: 'success',
          draft: 'gray',
          deleted: 'danger',
        }
        return statusMap[status]
      },
    },
    data() {
      return {
        dialogVisible:false,
        height: '73vh',
        imgShow: true,
        list: [],
        imageList: [],
        listLoading: true,
        layout: 'total, sizes, prev, pager, next, jumper',
        background: true,
        selectRows: '',
        elementLoadingText: '正在加载...',
        queryForm: {
          page: 1,
          limit: 10,
          total: 0,
        },
        value1: '',
        value: '',
        submit_form:{ //外层模版添加编辑表单
            name:null,
            status:0 ,//0正常1关闭
            sort:null,
            price:null,
        },
        rules:{
          name: [{ required: true, message: '请输入模版名称', trigger: 'blur' }],
          status: [{ required: true, message: '请设置模版状态', trigger: 'change' }],
        },
        isAdd:false,
        title:''
      }
    },
    // computed: {
    //   height() {
    //     return this.$baseTableHeight()
    //   },
    // },
    created() {
      this.fetchData()
    },
    beforeDestroy() {},
    mounted() {},
    methods: {
      handleSizeChange(val) {
        this.queryForm.limit = val
        this.fetchData()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.fetchData()
      },
      fetchData(){
        goodsPostagePostageList(this.queryForm).then(res=>{
          this.list = res.data.list
          this.queryForm.total = res.data.count
          this.listLoading = false
        })
      },
      // 外层邮费模版删除
      handleDelete(row){
        //
         this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
           confirmButtonText: '确定',
           cancelButtonText: '取消',
           type: 'warning'
         }).then(() => {
           goodsPostagePostageDel({id:row.id}).then(res=>{
             this.$message({
               type: 'success',
               message: '删除成功!'
             });
             this.fetchData()
           })
         }).catch(() => {
           this.$message({
             type: 'info',
             message: '已取消删除'
           });
         });
      },
      // 模版外层添加
      handleAdd(type){
        if(type>0){
          this.title = '编辑邮费模版'
          this.isAdd = false
          this.listLoading = true
          goodsPostagePostageDetail({id:type}).then(res=>{
            this.dialogVisible = true
            this.listLoading = false
            this.submit_form = res.data
          }).catch(err=>{
            this.listLoading = false
          })
        }else{
          this.title = '添加邮费模版'
          this.isAdd = true
          this.dialogVisible = true
        }

      },
      handleClose(){
        this.dialogVisible = false
      },
      submit_save(){
        this.$refs['ruleForm'].validate((valid) => {
          if (valid) {
            if(this.isAdd){
              console.log(this.submit_form)
              var data = {
                "name":this.submit_form.name, //
                "status": this.submit_form.status ,//0正常 1关闭
                price: this.submit_form.price ,
                sort: this.submit_form.sort ,
              }
              goodsPostagePostageAdd(this.submit_form).then(res=>{
                this.$message({
                  type:'success',
                  message:'操作成功'
                })
                this.fetchData()
                this.handleClose()
              })
            }else{
              goodsPostagePostageUpdate(this.submit_form).then(res=>{
                this.$message({
                  type:'success',
                  message:'操作成功'
                })
                this.fetchData()
                this.handleClose()
              })
            }
          } else {
            return false;
          }
        });

      },
      handleList(row){
        console.log(row.id)
        this.$router.push({path:`/parcelManagement/managePostageList?id=${row.id}`})
      }
    },
  }
</script>

<style>
  :deep .right-panel {
    display: flex;
    align-items: center;
  }

  .table {
    margin-top: 30px;
  }
</style>
